import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const send = (params, urlParams) => {
  return axios.request({
    url: '/ddm/shortmessage/send' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

